import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Clipboard } from '@angular/cdk/clipboard';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SignInComponent } from '../../../layout/component-layout/sign-in/sign-in.component';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { BehaviorSubject, filter, takeUntil } from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { Location } from '@angular/common';
import { AppState } from 'src/app/shareModule/states/app.state';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { FormForumComponent } from '../form-forum/form-forum.component';

@Component({
  selector: 'app-single-forum',
  templateUrl: './single-forum.component.html',
  styleUrls: ['./single-forum.component.scss'],
})
export class SingleForumComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  @ViewChild('forumForm') forumForm: FormForumComponent;
  @ViewChild('SignIn', { static: true }) signIn: SignInComponent;

  openTag: boolean = false;
  openAll: boolean = false;
  openThreads: boolean = false;
  currentUrl: string = '/forum'
  constructor(
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private clipboard: Clipboard,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    public roleSer: RoleService,
    private store: Store<AppState>,
    private seo: SeoService,
    private location: Location,
    private seoService: SeoService,
    private cdr: ChangeDetectorRef
  ) {

  }

  private modalRef: any;
  isLogin: any = 0;
  isLoading: boolean = false;
  appUserId: any;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: false,
    navSpeed: 700,
    smartSpeed: 4500,
    slideTransition: 'linear',
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      940: {
        items: 3,
      },
    },
    nav: true,
  };


  detailForum: any = {};
  showMessageBoxReply: boolean = false;
  imgUrl: string = environment.ImageUrl;
  public isUserDisabled: boolean = false;

  appUserLevel: any = 0;

  ngOnInit() {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.isUserDisabled = user?.isDisabled;
        this.appUserId = user.id;
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
    });



    this.route.params.subscribe((params) => {
      const slug = params['slug']
      if (slug) {
        this.showDetail(slug)
      }
    });

    this.sharedService.initTopic$.subscribe((e: any) => {
      if (e.type == 'init') {
        this.detailForum.slug = e?.slug?.slug ?? this.detailForum.slug;
        this.showDetail(this.detailForum.slug);
      }
    });

    this.store
      .pipe(select(selectUser))
      .pipe(filter((user) => !!user))
      .subscribe((res: User) => {
        this.appUserLevel = res.level;
      });

    // document.getElementsByTagName("body")[0].style.setProperty('background-color', 'rgb(105, 44, 189, 0.2)', 'important');

    this.isLoading = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack() {
    this.commonService.goBack()
  }

  isOwnMessage = (data: any) => {
    const user = this.local.getUser();
    if (!user) return false;
    return user.id == data.createdBy;
  };


  formatDate(value: any) {
    return moment.unix(value).format('YYYY-MM-DD HH:mm:ss');
  }
  loginHere() {
    this.signIn.loginStage = '';
    this.signIn.openSignInPopup();
  }

  initReply(id: number) {
    this.auth
      .marketplace_forum_shop_fetch_reply(id, 1, true)
      .subscribe((response: any) => {
        // this.shopForum.list[index].replies = response.body
        // this.shopForum.list[index].replies.map((row: any) => {
        //   row.user = row.user ?? {}
        //   row.createdAt = new Date(row.createdAt * 1000).toLocaleString()
        // })
        this.detailForum.replies = response.body;
        this.cdr.detectChanges();
      });
  }


  forumFormModal() {
    this.forumForm.forumFormModal(this.detailForum)
  }

  async handleShowOptionForumReply(index: number) {
    await Promise.all(
      this.detailForum?.replies.map((row: any, i: number) => {
        if (index != i) row.showOption = false;
        // row.isEdit = false
      })
    ).then(() => {
      this.detailForum.replies[index].showOption =
        !this.detailForum.replies[index].showOption;
    });
  }
  async handleShowOptionForumReplyChild(item: any) {
    item.showOption = !item.showOption;
  }

  storeForumMessageReply(id: number = null, item: any = null) {
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    const forum = item != null ? item : this.detailForum;
    const isChild = item != null;
    if (forum.replyText.length < 1 && id == null) {
      return this.toastr.error('Please Fill a Message !');
    }

    this.detailForum.hasSubmit = true;
    const parentChild = isChild ? forum.id : null;

    if (id != null) {
      forum.replyText = forum.messageEdit;
    }

    const form = {
      forumId: isChild ? forum.forumId : forum.id,
      message: forum.replyText,
      createdBy: this.appUserId,
      id: id,
      isChild: isChild,
      parentChild: parentChild,
    };

    try {
      this.auth.marketplace_forum_shop_store_reply(form).subscribe(() => {
        this.detailForum.hasSubmit = false;
        Swal.fire({
          title: 'Success',
          text: 'The message was successfully added',
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: 'var(--primary)',
          confirmButtonText: 'OK',
        }).then(() => {
          this.initReply(this.detailForum.id);
          this.showMessageBoxReply = false;
          this.cdr.detectChanges();
        });
        forum.replyText = '';
      });
    } catch (e) {
      this.detailForum.hasSubmit = false;
    }
  }
  storeForumMessageEdit(item: any) {
    this.storeForumMessageReply(item.id, item);
  }

  editForumMessage(event: any, item: any) {
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    event.preventDefault();
    item.isEdit = !item.isEdit;
    item.messageEdit = item.message;
    item.showOption = false;
  }

  editForumMessageReply(event: any, item: any) {
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    event.preventDefault();
    item.isEdit = !item.isEdit;
    item.messageEdit = item.message;
    item.showOption = false;
  }

  deleteForumMessageReply(event: any, id: any, index: number = null) {
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    event.preventDefault();
    this.local.alertConfirm({}).then((resp) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({});
        try {
          this.auth.marketplace_forum_shop_delete_reply(id).subscribe(() => {
            this.local.alertSuccess({}).then(() => {
              this.initReply(this.detailForum.id);
              this.cdr.detectChanges();
            });
          });
        } catch (e) {
          this.local.alertInternalError();
        }
      }
    });
  }


  showReplyMessageBox(event: any, item: any) {
    event.preventDefault();
    item.showReplyBox = !item.showReplyBox;

  }

  showDetail(slug: string) {


    // if (this.sharedService.isBrowser()) {
    this.location.replaceState(this.currentUrl + `/${slug}`)
    this.auth.forum_find(slug).subscribe((response: any) => {
      const item = response.body;

      if (item.length < 1) {
        this.toastr.warning('Forum Not Found');
        this.router.navigate(['/forum'])
        return;
      }

      this.seoService.update({
        title: item.title,
        description: this.removeHtmlTags(item.message)?.substr(0, 200),
        main_title: ' | BEST SERVICES SG'
      })
      this.seoService.initForumSchema(item)
      this.seoService.addMetaTags(item.metadata)


      if (!item.isPinned && !item.user.isAdmin) {
        this.seoService.updateNoIndex(true)
      }

      this.detailForum = item;
      this.detailForum.createdAtText = this.local.timeAgo(item.createdAt)
      this.detailForum.images = Array.isArray(this.detailForum?.images)
        ? this.detailForum.images
        : JSON.parse(this.detailForum?.images ?? '[]');
      this.initReply(item.id);
      if (this.isUserDisabled) {

        this.location.replaceState(this.currentUrl)
        return this.toastr.error('Your account is muted !');
      }
      if (this.appUserLevel < item.limitLevel) {
        this.location.replaceState(this.currentUrl)
        return this.toastr.warning('Your level is not high enough to enter');
      }
      this.cdr.detectChanges();

    }, (e) => {
      this.toastr.warning('Forum Not Found');
      this.router.navigate(['/forum'])
      this.cdr.detectChanges();
      return;
    });
    // }
  }

  removeHtmlTags(text: string): string {
    return text ? text.replace(/<[^>]*>/g, " ").replaceAll("&nbsp;", " ") : "";
  }

  copyLink(type: string, item: any) {
    let currentUrl = window.location.href.split('#')[0];
    currentUrl = currentUrl + '/forum';
    this.clipboard.copy(`${currentUrl}/${item.uuid}`);
    this.toastr.success(`${type.toLocaleUpperCase()} Link Copied`);
  }


  hasCheckedForum(data: any) {
    return data?.filter((row: any) => row.userId == this.appUserId)?.length > 0;
  }

  likeForum(forumId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    const payload = {
      userId: this.appUserId,
      forumId: forumId,
    };

    if (this.hasCheckedForum(data.forumLikes))
      data.forumLikes = data.forumLikes.filter(
        (row: any) => row.userId != this.appUserId
      );
    else data.forumLikes = [...data.forumLikes, payload];

    this.auth.forum_likes(payload).subscribe();
  }

  handleReport(id: any, category = 'forum') {
    this.forumForm.handleReport(id, category)
  }

  deletePost(event: any) {
    this.forumForm.deletePost(event, this.detailForum.id)
  }

  handleMuteForum(item: any) {
    this.auth
      .forum_mute({
        forumId: item.id,
      })
      .subscribe(
        () => {
          item.isMuted = !item.isMuted;
          this.toastr.success('Forum muted successfully');
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }
}
